import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  AlertCircle,
  CheckCircle2,
  Clock3,
  Headphones,
  Loader2,
  Send,
  Sparkles,
} from "lucide-react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import ScoreCardForWriting from "./ScoreCardForWritingSection";
import SpacingBox from "./Spacing";
import AudioPlayer from "./AudioPlayer";
import WriteBox from "./WordBox";
import useFetchData from "../fetchpostData";
import ScoreBoxForWritting from "./ResponseBoxForWrittingSection";
import Notification from "./Notification";
import Timers from "../PageComponent/Timers";
import Timer from "../MockTest/Timer";

const ListeningShell = ({ children }) => (
  <div className="min-h-screen bg-slate-50 text-gray-700">
    <Headerdash />
    <Sidebar />
    <main className="min-h-screen pt-20 sm:pl-72">
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        {children}
      </div>
    </main>
  </div>
);

const StatusPill = ({ type, children }) => {
  const styles =
    type === "success"
      ? "bg-green-50 text-green-700 ring-green-100"
      : type === "warning"
      ? "bg-amber-50 text-amber-700 ring-amber-100"
      : "bg-purple-50 text-purple-700 ring-purple-100";

  return (
    <span
      className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-bold uppercase ring-1 ${styles}`}
    >
      {children}
    </span>
  );
};

export default function SummarizeSpokenTextPage() {
  const { title } = useParams();

  const section = "summarizespokentext";
  const practiceItemId = title;

  const post = useFetchData(section, title);
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [audioLink, setaudioLink] = useState("");
  const [text, setText] = useState("");
  const [originalAnswer, setOriginalAnswer] = useState("");
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [savedPractice, setSavedPractice] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleTextChange = (newText) => {
    setText(newText);
  };

  useEffect(() => {
    console.log("Post Data :", post);

    if (post && post.media_link) {
      setOriginalWords(post.question);
      setOriginalAnswer(post.answer);
      setTitle(post.q_title);

      const fileName = encodeURIComponent(post.media_link.split("/").pop());

      fetch(`/ptedata/ptemedia/${fileName}`, { credentials: "include" })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setaudioLink(data.url);
          } else {
            console.error("Failed to fetch image URL");
          }
        })
        .catch((error) => console.error("Error fetching signed URL:", error));
    }
  }, [post]);

  console.log("Audio Link:", audioLink);
  console.log("Original Word:", originalWords);
  console.log("Original Word:", originalAnswer);
  console.log("User Answer Word:", text);

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-summarizespokentext", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    const answer = text;
    const practiceType = section;

    e.preventDefault();
    setLoading(true);

    const practiceData = {
      practiceType,
      practiceItemId,
      response: {
        questionId: practiceItemId,
        answer,
        isAttempted: true,
      },
    };
    console.log("practiceData:", practiceData);
    try {
      const result = await savePractice(practiceData);
      console.log("Practice data saved:", result);
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setSavedPractice(result);
      setShowNotification(true);

      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
        setSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error("Error saving practice data:", error);
      setMessage("Failed to save practice data.");
      setNotificationType("error");
      setShowNotification(true);
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  console.log("savedPractice", savedPractice);

  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";

  return (
    <ListeningShell>
      <section className="mb-6 flex flex-col gap-5 border-b border-slate-200 pb-6 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-sm font-semibold uppercase text-purple-700">
            Listening practice
          </p>
          <h1 className="mt-1 text-2xl font-extrabold text-gray-900 sm:text-3xl">
            {Title || "Summarize spoken text"}
          </h1>
          <p className="mt-2 max-w-2xl text-sm text-gray-500 sm:text-base">
            Listen to the lecture and write a concise summary of the key
            points.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <StatusPill>Medium</StatusPill>
          <StatusPill type={isAttempted ? "success" : "warning"}>
            {attemptedStatus}
          </StatusPill>
          <span className="inline-flex min-h-9 items-center gap-2 rounded-md bg-white px-3 py-2 text-sm font-bold text-gray-700 shadow-sm ring-1 ring-slate-200">
            <Clock3 className="h-4 w-4 text-purple-700" aria-hidden="true" />
            <Timers initialSeconds={0} />
          </span>
        </div>
      </section>

      <div className="grid gap-6 xl:grid-cols-[minmax(0,1fr),360px]">
        <div className="space-y-6">
          <section className="rounded-md border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
            <div className="flex items-start gap-3">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-purple-50 text-purple-700">
                <Headphones className="h-5 w-5" aria-hidden="true" />
              </span>
              <div>
                <p className="text-sm font-semibold uppercase text-purple-700">
                  Instructions
                </p>
                <h2 className="text-xl font-extrabold text-gray-900">
                  Listen, then summarize
                </h2>
                <p className="mt-2 text-sm leading-6 text-gray-600">
                  You will hear a short lecture. Write a summary for a fellow
                  student who was not present. You should write 50-70 words and
                  finish within 10 minutes.
                </p>
              </div>
            </div>
          </section>

          <section className="rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <div className="mb-4 flex items-center gap-3">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-purple-50 text-purple-700">
                <Headphones className="h-5 w-5" aria-hidden="true" />
              </span>
              <div>
                <p className="text-sm font-semibold uppercase text-purple-700">
                  Audio
                </p>
                <h2 className="text-lg font-extrabold text-gray-900">
                  Lecture playback
                </h2>
              </div>
            </div>
            {audioLink && <AudioPlayer audioSrc={audioLink} />}
          </section>

          <section className="rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-sm font-semibold uppercase text-purple-700">
                  Writing window
                </p>
                <h2 className="text-xl font-extrabold text-gray-900">
                  Compose your summary
                </h2>
              </div>
              <span className="inline-flex min-h-10 items-center rounded-md bg-purple-50 px-3 py-2 text-sm font-bold text-purple-800 ring-1 ring-purple-100">
                <Timer
                  initialMinutes={10}
                  initialSeconds={0}
                  Text="Time remaining"
                />
              </span>
            </div>

            <WriteBox
              onTextChange={handleTextChange}
              minHeight="min-h-[18rem]"
            />
          </section>

          <section className="flex flex-col gap-3 rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:flex-row sm:items-center sm:justify-between sm:p-5">
            <div className="flex items-start gap-3">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-purple-50 text-purple-700">
                <Sparkles className="h-5 w-5" aria-hidden="true" />
              </span>
              <div>
                <p className="text-sm font-semibold uppercase text-gray-500">
                  Ready to score?
                </p>
                <p className="text-sm text-gray-500">
                  Submit when your summary captures the lecture's key points.
                </p>
              </div>
            </div>

            <button
              type="button"
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-md bg-violet-600 px-5 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-70"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
                  Submitting...
                </>
              ) : (
                <>
                  <Send className="h-4 w-4" aria-hidden="true" />
                  Submit
                </>
              )}
            </button>
          </section>

          {submitted ? (
            <section className="space-y-5">
              <div className="rounded-md border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-5 flex items-center gap-3">
                  <span className="grid h-10 w-10 place-items-center rounded-md bg-green-50 text-green-700">
                    <CheckCircle2 className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <div>
                    <p className="text-sm font-semibold uppercase text-purple-700">
                      Result
                    </p>
                    <h2 className="text-xl font-extrabold text-gray-900">
                      Latest writing score
                    </h2>
                  </div>
                </div>

                <ScoreCardForWriting
                  finalScore={savedPractice?.savedResponse?.totalScore}
                  remarks={savedPractice?.savedResponse?.remarks}
                  contentScore={savedPractice?.savedResponse?.contentScore}
                  formScore={savedPractice?.savedResponse?.formScore}
                  grammarScore={savedPractice?.savedResponse?.grammarScore}
                  grammarSpellingScore={
                    savedPractice?.savedResponse?.grammarSpellingScore
                  }
                  vocabularyScore={savedPractice?.savedResponse?.vocabularyScore}
                  spellingScore={savedPractice?.savedResponse?.spellingScore}
                  maxScore={savedPractice?.maxScores?.total || 12}
                  contentMaxScore={savedPractice?.maxScores?.content || 4}
                  formMaxScore={savedPractice?.maxScores?.form || 2}
                  grammarMaxScore={savedPractice?.maxScores?.grammar || 2}
                  vocabularyMaxScore={
                    savedPractice?.maxScores?.vocabulary || 2
                  }
                  spellingMaxScore={savedPractice?.maxScores?.spelling || 2}
                />
              </div>
              {savedPractice?.summarizeSpokenTextScore?.feedback ? (
                <div className="rounded-md border border-slate-200 bg-white p-5 shadow-sm">
                  <p className="text-sm font-semibold uppercase text-purple-700">
                    AI Feedback
                  </p>
                  <p className="mt-2 text-sm leading-6 text-gray-600">
                    {savedPractice.summarizeSpokenTextScore.feedback.overall}
                  </p>
                  <div className="mt-4 grid gap-3 md:grid-cols-5">
                    <div className="rounded-md bg-blue-50 p-4 ring-1 ring-blue-100">
                      <h3 className="font-bold text-blue-800">Content</h3>
                      <p className="mt-2 text-sm text-blue-900">
                        {savedPractice.summarizeSpokenTextScore.feedback.content}
                      </p>
                    </div>
                    <div className="rounded-md bg-green-50 p-4 ring-1 ring-green-100">
                      <h3 className="font-bold text-green-800">Form</h3>
                      <p className="mt-2 text-sm text-green-900">
                        {savedPractice.summarizeSpokenTextScore.feedback.form}
                      </p>
                    </div>
                    <div className="rounded-md bg-purple-50 p-4 ring-1 ring-purple-100">
                      <h3 className="font-bold text-purple-800">Grammar</h3>
                      <p className="mt-2 text-sm text-purple-900">
                        {savedPractice.summarizeSpokenTextScore.feedback.grammar}
                      </p>
                    </div>
                    <div className="rounded-md bg-rose-50 p-4 ring-1 ring-rose-100">
                      <h3 className="font-bold text-rose-800">Spelling</h3>
                      <p className="mt-2 text-sm text-rose-900">
                        {savedPractice.summarizeSpokenTextScore.feedback.spelling}
                      </p>
                    </div>
                    <div className="rounded-md bg-orange-50 p-4 ring-1 ring-orange-100">
                      <h3 className="font-bold text-orange-800">Vocabulary</h3>
                      <p className="mt-2 text-sm text-orange-900">
                        {
                          savedPractice.summarizeSpokenTextScore.feedback
                            .vocabulary
                        }
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 grid gap-3 rounded-md bg-slate-50 p-4 text-sm text-gray-700 ring-1 ring-slate-100 sm:grid-cols-2 lg:grid-cols-6">
                    <span>
                      Words:{" "}
                      <strong>
                        {savedPractice.summarizeSpokenTextScore.word_count || 0}
                      </strong>
                    </span>
                    <span>
                      Semantic:{" "}
                      <strong>
                        {Math.round(
                          (savedPractice.summarizeSpokenTextScore
                            .semantic_similarity || 0) * 100
                        )}
                        %
                      </strong>
                    </span>
                    <span>
                      Main idea:{" "}
                      <strong>
                        {Math.round(
                          (savedPractice.summarizeSpokenTextScore
                            .main_idea_coverage || 0) * 100
                        )}
                        %
                      </strong>
                    </span>
                    <span>
                      Supporting:{" "}
                      <strong>
                        {Math.round(
                          (savedPractice.summarizeSpokenTextScore
                            .supporting_idea_coverage || 0) * 100
                        )}
                        %
                      </strong>
                    </span>
                    <span>
                      Coherence:{" "}
                      <strong>
                        {Math.round(
                          (savedPractice.summarizeSpokenTextScore
                            .coherence_score || 0) * 100
                        )}
                        %
                      </strong>
                    </span>
                    <span>
                      Template:{" "}
                      <strong>
                        {savedPractice.summarizeSpokenTextScore
                          .template_detected
                          ? "Detected"
                          : "Clear"}
                      </strong>
                    </span>
                  </div>
                </div>
              ) : null}
            </section>
          ) : null}
        </div>

        <aside className="space-y-6">
          <section className="rounded-md border border-slate-200 bg-white p-5 shadow-sm">
            <div className="flex items-start gap-3">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-amber-50 text-amber-700">
                <AlertCircle className="h-5 w-5" aria-hidden="true" />
              </span>
              <div>
                <p className="text-sm font-semibold uppercase text-gray-500">
                  Practice tip
                </p>
                <p className="mt-1 text-sm leading-6 text-gray-600">
                  Note the main topic, two or three supporting points, and the
                  speaker's conclusion. Keep the summary compact.
                </p>
              </div>
            </div>
          </section>

          <ScoreBoxForWritting
            originalWords={originalAnswer}
            practiceItemId={practiceItemId}
            onIsAttempted={handleIsAttempted}
          />
        </aside>
      </div>

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}

      <SpacingBox />
    </ListeningShell>
  );
}
